import Detail from '../press/[id]';

export default Detail;
